// import {Component}            from '@angular/core';

// @Component({
// 	template:'ContentNode'
// })
export class ContentNode {
	constructor(
		public CATEGORY_ID:number,
		public PARENT_CATEGORY_ID: number,
		public CATEGORY_CODE: string,
		public CATEGORY_DESC: string,
		public CATEGORY_TYPE_ID: number,
		public PARENT_CATEGORY_CODE: string,
		public HasChildren:boolean = true
	) { 
		this.HasChildren = HasChildren; 
	}

	public hasChildren(){
		debugger;
		return true;
	}
}


// WEBPACK FOOTER //
// ./src/app/content-node.ts